import React from 'react'

const Tuple_Cube = () => {
    return (
        <div className='container'>
            <h1>Program to create a list of tuples from the given list having the number and its cube in each tuple</h1>
            <div className='containers'>
            Given list input, we need to create a tuple with numbers and their corresponding cubes. <br />

            </div>
       <div className='containers'>
            <pre class="prettyprint notranslate prettyprinted"><span class="keywords">list1 </span><span class="pun">=</span><span class="keywords"> </span><span class="pun">[</span><span class="lit">0</span><span class="pun">,</span><span class="lit">1</span><span class="pun">,</span><span class="lit">2</span><span class="pun">,</span><span class="lit">4</span><span class="pun">,</span><span class="lit">6</span><span class="pun">]</span><span class="keywords"><br />
res </span><span class="pun">=</span><span class="keywords"> </span><span class="pun">[(</span><span class="keywords">val</span><span class="pun">,</span><span class="keywords"> pow</span><span class="pun">(</span><span class="keywords">val</span><span class="pun">,</span><span class="keywords"> </span><span class="lit">3</span><span class="pun">))</span><span class="keywords"> </span><span class="kwd">for</span><span class="keywords"> val </span><span class="kwd">in</span><span class="keywords"> list1</span><span class="pun">]</span><span class="keywords"><br />
</span><span class="comment"># main</span><span class="keywords"> <br />
</span><span class="kwd">print</span><span class="pun">(</span><span class="keywords">res</span><span class="pun">)</span></pre>
     </div>   
     <div className='output'>
         <p>Output</p> <br />
     [(0, 0), (1, 1), (2, 8), (4, 64), (6, 216)]
     </div>
     </div>
    )
}

export default Tuple_Cube
